<fstr-youtube-player
  #youtube
  [src]="data.url"
  [config]="youtubeConfig"
  [cookies]="cookiePreferences$()?.marketing || false"
></fstr-youtube-player>
